<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-07-07 16:58:12
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-09-12 15:07:39
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/ES/ESapply/editProductEvaluation.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- 我的产品评价 -->
<template>
  <div>
    <div class="form-container">
      <div class="form-title">我的产品评价</div>
      <eSteps :step-list="stepList" :is-active="isActive"></eSteps>
    </div>
    <div v-if="routeFrom === 'myApplyPage'" class="form-container">
      <div class="form-title margin-b-20">订单信息</div>
      <orderInfo :apply-info="applyInfo"></orderInfo>
    </div>
    <div class="form-container">
      <div class="form-title margin-b-20">评价信息</div>
      <evaluationInfo
        :apply-id="applyId"
        :apply-status="applyStatus"
        @handleRemark="handleRemark"
      ></evaluationInfo>
    </div>
    <div
      v-if="
        routeFrom !== 'applyPage' &&
        applyStatus !== 205 &&
        applyStatus !== 218 &&
        applyStatus !== 217 &&
        applyStatus !== 219 &&
        applyStatus !== 201
      "
      class="form-container"
    >
      <div class="form-title margin-b-20">供应商信息</div>
      <supplierInfo
        :apply-info="applyInfo"
        @changeConfirm="changeConfirm"
      ></supplierInfo>
    </div>
    <div class="form-container">
      <div class="form-title margin-b-20">产品质量评价申请人信息</div>
      <applyInfo ref="applyInfo" :apply-info-form="applyInfoForm"></applyInfo>
    </div>
    <div class="form-container">
      <div class="form-title margin-b-20">发票信息详情</div>
      <invoiceDetail
        :invoice-list="invoiceList"
        :is-current-invoice="isCurrentInvoice"
        @handleSelectInvoice="handleSelectInvoice"
        @handleInvoiceFold="handleInvoiceFold"
        @updateInvoiceList="updateInvoiceList"
      ></invoiceDetail>
    </div>
    <div class="form-container">
      <div class="form-title margin-b-20">发票邮寄信息</div>
      <invoiceAddress
        :invoice-list="invoiceAddressList"
        :is-current-invoice="isCurrentInvoiceAddress"
        @handleSelectInvoiceAddress="handleSelectInvoiceAddress"
        @handleInvoiceAddressFold="handleInvoiceFoldAddress"
        @updateInvoiceListAddress="updateInvoiceListAddress"
      ></invoiceAddress>
    </div>
    <div v-if="applyType" class="form-container">
      <div class="form-title margin-b-20">附件上传</div>
      <attachmentUpload
        :url="attachmentFileUrl"
        @getUploadFileList="getUploadFileList"
      ></attachmentUpload>
    </div>
    <div class="btn-wrap">
      <eui-btn
        v-debounce="submitApplyInfo"
        type="primary"
        :disabled="isChecked && applyStatus === 218"
        >提交申请</eui-btn
      >
    </div>
  </div>
</template>

<script>
import eSteps from '../../../components/common/e-steps.vue';
import evaluationInfo from './component/evaluationInfo.vue';
import applyInfo from './component/applyInfoForm.vue';
import invoiceDetail from './component/invoiceDetailForm.vue';
import invoiceAddress from './component/invoiceAddressForm.vue';
import attachmentUpload from './component/attachmentUpload.vue';
import orderInfo from './component/orderInfo.vue';
import supplierInfo from './component/supplierInfo.vue';
import api from '../../../api/evaluation/index';

export default {
  components: {
    eSteps,
    evaluationInfo,
    applyInfo,
    invoiceDetail,
    invoiceAddress,
    attachmentUpload,
    orderInfo,
    supplierInfo,
  },
  data() {
    return {
      isActive: 0,
      stepList: [
        {
          id: 1,
          title: '提交申请',
        },
        {
          id: 2,
          title: '确认申请',
        },
        {
          id: 3,
          title: '支付完成',
        },
        {
          id: 4,
          title: '审核通过',
        },
        {
          id: 5,
          title: '评价完成',
        },
      ],
      invoiceList: [], // 发票信息list
      isCurrentInvoice: null,
      invoiceAddressList: [], // 发票邮寄地址list
      isCurrentInvoiceAddress: null, // 当前邮寄地址
      applyInfoForm: {
        applicant: null,
        mobile: null,
        email: null,
        address: null,
        factory: null,
      },
      isChecked: true,
      attachmentFile: [],
      applyType: true, // 是否需要附件
      routeFrom: null,
      applyId: null,
      applyStatus: null,
      applyInfo: {},
      remarkList: [], // 有备注时提交信息
      attachmentFileUrl: [], // 回显上传的
    };
  },

  computed: {},

  async created() {
    console.log(this.$route.query);
    // 路由来自产品评价申请页面applyPage  我的产品质量评价myApplyPage
    // if (this.$route.query.from === 'applyPage') {
    //   this.applyId = this.$route.query.applyId;
    // }
    this.applyId = Number(this.$route.query.applyId);
    this.routeFrom = this.$route.query.from;
    if (this.routeFrom === 'myApplyPage' || this.routeFrom === 'applyPage') {
      this.applyStatus = Number(this.$route.query.applyStatus);
    }
    await this.getInvoiceList(this.applyId);
    await this.getInvoiceAddressList(this.applyId);
    await this.getEvaluationInfo(this.applyId);
    await this.handleSteps(this.applyStatus, this.stepList);
  },
  methods: {
    //  评价申请人信息===========
    async getEvaluationInfo(applyId) {
      const res = await api.getEvaluationApplyDetail({ applyId });
      if (res.code === '200') {
        const {
          applicant = null,
          mobile = null,
          email = null,
          address,
          factory = null,
          isUploadAgreement,
          evaluationApplyCommissionAttachmentVO = null,
        } = res.data;
        // this.applyInfoForm = {
        //   applicant: applicant,
        //   mobile: mobile,
        //   email: email,
        //   address: address,
        //   factory: factory
        // };
        this.$set(this.applyInfoForm, 'applicant', applicant);
        this.$set(this.applyInfoForm, 'mobile', mobile);
        this.$set(this.applyInfoForm, 'email', email);
        this.$set(this.applyInfoForm, 'address', address);
        this.$set(this.applyInfoForm, 'factory', factory);
        this.applyInfo = res.data;
        this.applyType = Number(isUploadAgreement) === 1;
        console.log(evaluationApplyCommissionAttachmentVO);
        if (evaluationApplyCommissionAttachmentVO != null) {
          this.assemblyAttachmentFileUrl(evaluationApplyCommissionAttachmentVO);
        }
        console.log(this.attachmentFileUrl);
      }
    },

    // 发票信息操作==============
    // 获取发票list
    async getInvoiceList(applyId) {
      const res = await api.queryByApplyId({ applyId });
      if (res.code === '200') {
        this.invoiceList = res.data;
        this.isCurrentInvoice =
          this.invoiceList.length > 0 ? this.invoiceList[0].invoiceId : null;
      }
    },
    // 选择发票
    handleSelectInvoice(options) {
      this.isCurrentInvoice = options.invoiceId;
      console.log(this.isCurrentInvoice, '当前选中发票抬头信息');
    },
    // 处理发票收起
    handleInvoiceFold(index) {
      const newArr = this.invoiceList.splice(index, 1);
      this.invoiceList.unshift(newArr[0]);
      console.log(this.invoiceList);
    },
    //  更新发票列表
    async updateInvoiceList() {
      await this.getInvoiceList(this.applyId);
    },

    // 发票邮寄地址操作=============
    // 选择邮寄地址
    handleSelectInvoiceAddress(options) {
      this.isCurrentInvoiceAddress = options.addressId;
      console.log(this.isCurrentInvoiceAddress, '当前选中发票邮寄地址信息');
    },
    // 收起邮寄地址
    handleInvoiceFoldAddress(index) {
      const newArr = this.invoiceAddressList.splice(index, 1);
      this.invoiceAddressList.unshift(newArr[0]);
      console.log(this.invoiceAddressList);
    },
    // 更新邮寄地址
    updateInvoiceListAddress() {
      this.getInvoiceAddressList(this.applyId);
    },
    // 获取发票邮寄地址list
    async getInvoiceAddressList(applyId) {
      const res = await api.queryInvoiceAddressByApplyId({ applyId });
      if (res.code === '200') {
        this.invoiceAddressList = res.data;
        this.isCurrentInvoiceAddress =
          this.invoiceAddressList.length > 0
            ? this.invoiceAddressList[0].addressId
            : null;
      }
    },
    // 获取附件
    getUploadFileList(options) {
      this.attachmentFile = options;
    },

    // 提交申请
    submitApplyInfo() {
      console.log(this.applyInfoForm);
      this.$refs.applyInfo.submitForm(async (result) => {
        console.log(this.invoiceList);
        console.log(result);
        if (!result) {
          return;
        }
        if (this.isCurrentInvoice === null) {
          this.$message.warning('请选择发票信息');
          return false;
        }
        if (this.isCurrentInvoiceAddress === null) {
          this.$message.warning('请选择发票邮寄地址');
          return false;
        }
        if (this.applyType && this.attachmentFile.length === 0) {
          this.$message.warning('请上传产品质量评价委托协议。');
          return;
        }
        let params = {};
        const { applicant, mobile, email, address, factory } =
          this.applyInfoForm;
        const invoiceAddAO =
          this.invoiceList.length > 0
            ? this.assemblyInvoiceParams(
                'invoiceId',
                this.isCurrentInvoice,
                this.invoiceList
              )
            : [];

        const memberAddressAddAO =
          this.invoiceAddressList.length > 0
            ? this.assemblyInvoiceParams(
                'addressId',
                this.isCurrentInvoiceAddress,
                this.invoiceAddressList
              )
            : [];
        memberAddressAddAO.location = `${memberAddressAddAO.provinceAreaId},${memberAddressAddAO.cityAreaId},${memberAddressAddAO.countryAreaId}`;
        const evaluationApplyCommissionAttachmentAO =
          this.assemblyAttachmentParams(this.attachmentFile);
        params = {
          applyId: this.applyId,
          applicant,
          mobile,
          email,
          address,
          factory,
          invoiceAddAO,
          memberAddressAddAO,
          evaluationApplyCommissionAttachmentAO: this.applyType
            ? {
                agreementName:
                  evaluationApplyCommissionAttachmentAO[0].agreementName,
                agreementPath:
                  evaluationApplyCommissionAttachmentAO[0].agreementPath,
              }
            : {},
          evaluationApplyItemPriceAOList: this.applyInfo.productRemarkFlag
            ? this.remarkList
            : [],
        };

        const res = await api.addEvaluationApplyCommissionInfo(params);
        if (res.code === '200') {
          this.$message.success('提交成功');
          this.$router.push({ path: '/ES/ESapply' });
        }
      });
    },
    // 组装发票及发票邮寄地址信息
    assemblyInvoiceParams(itemName, id, list) {
      let info = {};
      list.forEach((item) => {
        if (Number(item[itemName]) === Number(id)) {
          info = item;
        }
      });
      return info;
    },
    // 组装提交参数附件
    assemblyAttachmentParams(arr) {
      console.log(arr);
      const tempArr = [];
      arr.forEach((item) => {
        tempArr.push({
          agreementName: item.fileName,
          agreementPath: item.fileUrl,
        });
      });
      return tempArr;
    },
    // 组装回显附件数据
    assemblyAttachmentFileUrl(attachmentFileObj) {
      // this.attachmentFileUrl = [
      //   {
      //     fileUrl: attachmentFileObj.agreementPath,
      //     fileName: attachmentFileObj.agreementName
      //   }
      // ];
      this.attachmentFile = [
        {
          fileUrl: attachmentFileObj.agreementPath,
          fileName: attachmentFileObj.agreementName,
        },
      ];
      this.attachmentFileUrl.push({
        fileUrl: attachmentFileObj.agreementPath,
        fileName: attachmentFileObj.agreementName,
      });
    },

    changeConfirm(isChecked) {
      this.isChecked = !isChecked;
    },
    // 选择备注
    handleRemark(options) {
      console.log(options);
      options.forEach((item) => {
        this.remarkList.push({ productRemark: item.productRemark, id });
      });
    },
    // 处理步骤条展示
    handleSteps(status, stepList) {
      for (let i = 0; i < stepList.length; i++) {
        if (status === 219) {
          stepList[0].description = this.applyInfo.flowTime101;
          stepList[1].title = '申请驳回';
          stepList[1].description = this.applyInfo.flowTime110
            ? this.applyInfo.flowTime110
            : this.applyInfo.flowTime114;
          this.isActive = 1;
        }
        if (status === 206) {
          stepList[0].description = this.applyInfo.flowTime101;
          stepList[1].title = '提交确认';
          stepList[1].description = this.applyInfo.flowTime110;
          stepList[2].title = '支付完成';
          stepList[2].description = this.applyInfo.flowTime102;
          stepList[3].title = '资料初审';
          this.isActive = 3;
        }
        if (status === 207) {
          stepList[0].description = this.applyInfo.flowTime101;
          stepList[1].title = '提交确认';
          stepList[1].description = this.applyInfo.flowTime110;
          stepList[2].title = '支付完成';
          stepList[2].description = this.applyInfo.flowTime102;
          stepList[3].title = '审核驳回';
          stepList[3].description = this.applyInfo.flowTime103;
          this.isActive = 3;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  color: #333;
  font-size: 16px;
  line-height: 1;
}
.margin-b-20 {
  margin-bottom: 20px;
}
.btn-wrap {
  text-align: center;
}
</style>
